import BandeiraCartaoService from "@/services/BandeiraCartaoService";

export const actions = {
  cadastrarBandeiraCartao: ({ commit, dispatch }) => {
    commit("setBandeiraCartao", {
      nome: "",
    }),
      dispatch("setModalCadastroBandeiraCartao", true);
  },
  listarBandeiraCartao: ({ commit }, data) => {
    commit("setOverlay", true);
    BandeiraCartaoService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setBandeirasCartao", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  visualizarBandeiraCartao: ({ commit, dispatch }, data) => {
    commit("setBandeiraCartao", data);
    dispatch("setModalCadastroBandeiraCartao", true);
  },
  salvarBandeiraCartao: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    console.log("data", data);
    BandeiraCartaoService.salvar(data)
      .then((res) => {
        commit("addBandeiraCartao", res.data);
        commit("setBandeiraCartao", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Bandeira cadastrada.");
        dispatch("setModalCadastroBandeiraCartao", false);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarBandeiraCartao: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    BandeiraCartaoService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Bandeira atualizada.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirBandeiraCartao: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirBandeiraCartao", false);
    dispatch("setModalCadastroBandeiraCartao", false);
    BandeiraCartaoService.excluir(data.id)
      .then((res) => {
        commit("removeBandeiraCartao", data);
        commit("setOverlay", false);
        commit("snackbarError", "Bandeira excluída.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir bandeira.");
      });
  },
  setModalCadastroBandeiraCartao: ({ commit }, status) => {
    commit("setModalCadastrarBandeiraCartao", false);
    setTimeout(() => {
      commit("setModalCadastrarBandeiraCartao", status);
    }, 100);
  },
  setModalExcluirBandeiraCartao: ({ commit }, status) => {
    commit("setModalExcluirBandeiraCartao", false);
    setTimeout(() => {
      commit("setModalExcluirBandeiraCartao", status);
    }, 100);
  },
};

export default {};
